import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { Storage } from '@/utils/Storage';
import { v4 as uuidv4 } from 'uuid';
import withRouter from '@/components/withRouter';
// 预留外部智能体的初始逻辑
const WebOutSideLayout = (props) => {
    let { grtAi, chatStore } = props.store;
    let { agentId } = props.params;

    const initLocalId = () => {
        let LocalOuid = Storage.get('ouid');
        if (!LocalOuid) {
            let uuid = uuidv4();
            Storage.set('ouid', uuid);
        }
    };
    const init = async () => {
        chatStore.setAgentId(agentId);
        chatStore.setNavigate(props.navigate);
        grtAi.setAgentId(agentId);
        grtAi.setNavigate(props.navigate);
        grtAi.setSide('web');
        grtAi.setSearchParams(props.searchParams);
        await grtAi.checkLogin(true);
        initLocalId();
    };
    useEffect(() => {
        init();
    }, []);
    return <Outlet></Outlet>;
};
export default withRouter(inject('store')(observer(WebOutSideLayout)));
